export function exists<V>(
  value: V | 0 | -0 | 0n | '' | null | undefined | false,
): value is V {
  return !!value;
}
